import { config, getClientHeaders } from '../../config/index'
import { FirebaseApp } from '../firebase'
import { Moises } from './modules/moises'

// Clean exports
export { FirebaseApp }
export { Moises }
export type { File, Config } from './types'
export { MoisesAuth } from './modules/auth'
export { MoisesUpload } from './modules/upload'
export { MoisesTask } from './modules/task'
export { MoisesGraphQL } from './modules/graphql'

// Create the instance similar to how moisesSDK was created
export const moisesAPI = new Moises({
  apiEndpoint: config.api.endpoint,
  urlDownloadEndpoint: config.urlDownload.endpoint,
  headers: {
    ...getClientHeaders()
  },
  recaptchaToken: config.firebase.recaptchaToken,
  firebase: {
    appId: config.firebase.auth.appId,
    apiKey: config.firebase.auth.apiKey,
    authDomain: config.firebase.auth.authDomain,
    databaseURL: config.firebase.auth.databaseURL,
    projectId: config.firebase.auth.projectId,
    storageBucket: config.firebase.auth.storageBucket,
    messagingSenderId: config.firebase.auth.messagingSenderId
  }
})

// For backward compatibility, export as moisesSDK
export const moisesSDK = moisesAPI
